var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 58,
    viewBox: "0 0 52 58",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9575 8.07177L18.8555 10.3677L23.9575 12.6636L26.2534 17.7656L28.5493 12.6636L33.6514 10.3677L28.5493 8.07177L26.2534 2.96973L23.9575 8.07177Z",
    stroke: "#35323C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89695 12.4175L5.08203 13.6842L7.89695 14.9509L9.16366 17.7658L10.4304 14.9509L13.2453 13.6842L10.4304 12.4175L9.16366 9.60254L7.89695 12.4175Z",
    fill: "#35323C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5688 12.4175L38.7539 13.6842L41.5688 14.9509L42.8355 17.7658L44.1023 14.9509L46.9172 13.6842L44.1023 12.4175L42.8355 9.60254L41.5688 12.4175Z",
    fill: "#35323C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08203 28.9492C5.08203 27.8447 5.97746 26.9492 7.08203 26.9492H18.0004C22.4187 26.9492 26.0004 30.5309 26.0004 34.9492V51.6144H7.08203C5.97746 51.6144 5.08203 50.719 5.08203 49.6144V28.9492Z",
    stroke: "#35323C",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 34.9492C26 30.5309 29.5817 26.9492 34 26.9492H44.9184C46.0229 26.9492 46.9184 27.8446 46.9184 28.9492V49.6144C46.9184 50.719 46.0229 51.6144 44.9184 51.6144H26V34.9492Z",
    stroke: "#35323C",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1836 33.582H20.3877",
    stroke: "#35323C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1836 37.709H20.3877",
    stroke: "#35323C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1836 41.7686H20.3877",
    stroke: "#35323C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1836 45.8271H20.3877",
    stroke: "#35323C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6133 33.4961H41.8174",
    stroke: "#35323C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6133 37.6523H41.8174",
    stroke: "#35323C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6133 41.7393H41.8174",
    stroke: "#35323C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6133 45.8271H36.7153",
    stroke: "#35323C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2448 19.3757C16.5284 19.0264 23.2148 19.5226 23.6917 24.3024",
    stroke: "#35323C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M38.595 19.3757C35.3114 19.0264 28.625 19.5226 28.1482 24.3024",
    stroke: "#35323C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08163 33.582H5C2.79086 33.582 1 35.3729 1 37.582V52.031C1 54.2402 2.79086 56.031 5 56.031H47C49.2091 56.031 51 54.2402 51 52.031V37.582C51 35.3729 49.2091 33.582 47 33.582H46.9184",
    stroke: "#35323C",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoryIcon);
export default __webpack_public_path__ + "static/media/StoryIcon.73e40e88e0a5ada6995cd46b3d70cb38.svg";
export { ForwardRef as ReactComponent };